import React from 'react'
import Container from '@/components/Container/index'
import { Button, Form, Radio, Select, message } from 'antd'
import { connect } from 'dva';

import style from './index.less'

const { Option } = Select;
const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
  },
};

@connect(({ getPushRuless }) => ({
  ...getPushRuless,
}))
class BasicWrapper extends React.Component {
  componentDidMount () {
    this.getPushrules()
    const { dispatch } = this.props
    return dispatch({
      type: 'getPushRuless/ismanager'
    })
  }

  handleSubmit = e => {
    const { manager } = this.props
    const { result } = manager
    if (result) {
      e.preventDefault();
      const { form, basicinfo } = this.props
      form.validateFields((err, values) => {
        if (!err) {
          const { dispatch } = this.props;
          dispatch({
            type: 'getPushRuless/subbasic',
            payload: {
              id: (basicinfo || {}).id ? (basicinfo || {}).id : null,
              birthdayRankDays: parseInt(values.select, 10),
              wthrBirthdayModify: values.radiobr,
              wthrSendMsg: values.radiogift,
              employeeRankDays: parseInt(values.selectentry, 10),
              wthrEmployeeModify: values.radioentry,
              remindPerfectMsg: parseInt(values.radioperfect, 10)
            }
          })
        }
      });
    } else {
      message.error("对不起，您还没有该权限，请联系管理员开通！")
    }

  };

  getPushrules = () => {
    const { dispatch } = this.props;
    dispatch({
      type: 'getPushRuless/getbasicInfo'
    })
  }

  render () {
    const { form, basicinfo } = this.props
    const { birthdayRankDays, wthrBirthdayModify, employeeRankDays, wthrEmployeeModify, wthrSendMsg, remindPerfectMsg } = basicinfo || {}
    const { getFieldDecorator } = form;
    return (
      <div className={style.basic_root}>
        <Container>
          <div className={style.basic_header}>
            基础设置
          </div>
          <Form
            {...layout}
            name="basic"
            onSubmit={this.handleSubmit}
            labelAlign='right'
          >
            <Form.Item name="radiobr" label="修改生日信息">
              {getFieldDecorator('radiobr', { initialValue: (wthrBirthdayModify || {}) ? wthrBirthdayModify : '1' })(
                <Radio.Group>
                  <Radio value="1">教师可自行修改</Radio>
                  <Radio value="0">教师不可自行修改</Radio>
                </Radio.Group>
              )
              }
            </Form.Item>
            <Form.Item name="radioentry" label="修改入职信息">
              {getFieldDecorator('radioentry', { initialValue: (wthrEmployeeModify || {}) ? wthrEmployeeModify : '1' })(
                <Radio.Group>
                  <Radio value="1">教师可自行修改</Radio>
                  <Radio value="0">教师不可自行修改</Radio>
                </Radio.Group>
              )}
            </Form.Item>
            <Form.Item
              name="select"
              label="生日提醒"
              hasFeedback
            >
              显示
              {
                getFieldDecorator('select', { initialValue: (birthdayRankDays || '') ? `${birthdayRankDays}` : `3` })(
                  <Select>
                    <Option value="3">3天</Option>
                    <Option value="7">7天</Option>
                    <Option value="30">30天</Option>
                  </Select>
                )
              }
              生日的寿星
            </Form.Item>
            <Form.Item
              name="selectentry"
              label="入职周年提醒"
              hasFeedback
              rules={[{ required: true, message: 'Please select your country!' }]}
            >
              显示
              {
                getFieldDecorator('selectentry', {
                  initialValue: (employeeRankDays || '') ? `${employeeRankDays}` : `3`
                })(
                  <Select>
                    <Option value="3">3天</Option>
                    <Option value="7">7天</Option>
                    <Option value="30">30天</Option>
                  </Select>
                )
              }
              入职周年的教师
            </Form.Item>
            <Form.Item name="radiogift" label="教师间送礼物推送：">
              {getFieldDecorator('radiogift', { initialValue: (wthrSendMsg || {}) ? wthrSendMsg : '1' })(
                <Radio.Group>
                  <Radio value="1">推送消息</Radio>
                  <Radio value="0">不推送消息</Radio>
                </Radio.Group>
              )}
            </Form.Item>
            <Form.Item name="radioperfect" label="定期提醒完善信息：">
              {getFieldDecorator('radioperfect', { initialValue: (remindPerfectMsg || {}) ? `${remindPerfectMsg}` : '2' })(
                <Radio.Group>
                  <Radio value="1">7天提醒1次</Radio>
                  <Radio value="2">15天提醒1次</Radio>
                  <Radio value="0">不提醒</Radio>
                </Radio.Group>

              )}
              <div style={{ color: 'rgba(0, 0, 0, 0.45)', fontSize: '7.5px' }}>说明：定期对未完善生日信息或入职信息的人员推送完善信息提醒消息</div>
            </Form.Item>
          </Form>
        </Container>
        <div className={style.basic_footer}>
          <Button type="primary" htmlType="submit" onClick={this.handleSubmit}>保存</Button>
        </div>
      </div>
    )
  }
}

const BasicWrappers = Form.create({ name: 'validate_other' })(BasicWrapper);

export default BasicWrappers;